import { render, staticRenderFns } from "./PVBankAccountList.vue?vue&type=template&id=fb06aa4a&scoped=true&lang=pug"
import script from "./PVBankAccountList.vue?vue&type=script&lang=js"
export * from "./PVBankAccountList.vue?vue&type=script&lang=js"
import style0 from "./PVBankAccountList.vue?vue&type=style&index=0&id=fb06aa4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb06aa4a",
  null
  
)

export default component.exports